<p>dashboard-view works!</p>
